import { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faBars } from "@fortawesome/free-solid-svg-icons";

const links = [
  { label: "Home", href: "https://www.asmi.ro/" },
  { label: "Departamente", href: "https://www.asmi.ro/Departamente" },
  { label: "Articole", href: "https://www.asmi.ro/Articole" },
  { label: "Studenți", href: "https://www.asmi.ro/Studenti" },
  { label: "Elevi", href: "https://www.asmi.ro/Elevi" },
  { label: "Proiecte", href: "https://www.asmi.ro/Proiecte" },
  { label: "Smarthack", href: "https://smarthack.asmi.ro/" },
  { label: "Cariere", href: "https://cariere.asmi.ro/", external: true },
  {
    label: "Calendar ASMI & FMI",
    href: "https://www.asmi.ro/CalendarASMI",
    lines: ["Calendar", "ASMI & FMI"],
  },
  { label: "Galerie", href: "https://www.asmi.ro/Galerie" },
];

const NavbarComponent = () => {
  const [open, setOpen] = useState(false);

  const closeMenu = () => setOpen(false);

  return (
    <nav id="asmi-navbar" className="asmi-navbar">
      <div className="asmi-navbar__inner">
        <a className="asmi-navbar__brand" href="https://www.asmi.ro/">
          <img
            src={`${process.env.PUBLIC_URL}/images/asmi-1.png`}
            alt="ASMI"
            width="100"
            height="50"
          />
        </a>

        <button
          className="asmi-navbar__toggler"
          type="button"
          aria-controls="asmi-nav-content"
          aria-expanded={open}
          aria-label="Toggle navigation"
          onClick={() => setOpen((isOpen) => !isOpen)}
        >
          <FontAwesomeIcon icon={faBars} />
        </button>

        <div
          className={`asmi-navbar__collapse${open ? " is-open" : ""}`}
          id="asmi-nav-content"
        >
          <ul className="asmi-navbar__links">
            {links.map((link) => (
              <li key={link.label}>
                <a
                  href={link.href}
                  target={link.external ? "_blank" : undefined}
                  rel="noreferrer"
                  onClick={closeMenu}
                >
                  {link.lines ? (
                    <span className="asmi-navbar__stack">
                      <span>{link.lines[0]}</span>
                      <span>{link.lines[1]}</span>
                    </span>
                  ) : (
                    link.label
                  )}
                </a>
              </li>
            ))}
          </ul>
          <ul className="asmi-navbar__actions">
            <li>
              <a
                className="asmi-navbar__featured"
                href="https://recrutari.asmi.ro/"
                onClick={closeMenu}
              >
                Recrutări
              </a>
            </li>
            <li>
              <a
                className="asmi-navbar__problem"
                href="https://www.asmi.ro/ButonulRosu"
                onClick={closeMenu}
              >
                Ai o problemă?
              </a>
            </li>
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default NavbarComponent;
